import React from 'react';
import {
  HiOutlinePaperClip,
  HiOutlineDocumentText,
  HiOutlinePhotograph,
  HiOutlineFilm,
} from 'react-icons/hi';
import { filePublicUrl } from '../../services/api';

export const formatSize = (bytes) => {
  if (!bytes || bytes <= 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${Math.round((bytes / (1024 * 1024)) * 10) / 10} MB`;
};

export const fileIcon = (mime) => {
  if (mime?.startsWith('image/')) return HiOutlinePhotograph;
  if (mime?.startsWith('video/')) return HiOutlineFilm;
  return HiOutlineDocumentText;
};

// Pure display of a specific message/activity's own attachments — no upload
// UI, no "No files attached yet" placeholder (most messages have none, so
// that would be noisy under every single one). Renders nothing when empty.
// For the ticket-level legacy flat attachment list + uploader, see
// TicketAttachments.jsx (which reuses the same row markup via this file).
const InlineAttachments = ({ attachments = [] }) => {
  if (!attachments || attachments.length === 0) return null;

  return (
    <div className="mt-2 space-y-1.5">
      {attachments.map((a) => {
        const Icon = fileIcon(a.mimeType);
        return (
          <a
            key={a._id || a.fileName}
            href={filePublicUrl(a.url)}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2.5 p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors"
            title={`Open ${a.originalName}`}
          >
            <span className="w-8 h-8 rounded-lg bg-white border border-gray-200 flex items-center justify-center flex-shrink-0">
              <Icon className="w-4 h-4 text-gray-500" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-xs font-medium text-gray-800 truncate">
                {a.originalName}
              </span>
              <span className="block text-[10px] text-gray-400">
                {formatSize(a.size)}
              </span>
            </span>
            <HiOutlinePaperClip className="w-3.5 h-3.5 text-gray-300 flex-shrink-0" />
          </a>
        );
      })}
    </div>
  );
};

export default InlineAttachments;
